module.exports = __webpack_public_path__ + "img/banner4-4.adbb7b8c.png";